export default {
  day: '天',
  hour: '小时',
  min: '分钟',
  sesc: '秒',
  cancel: '取消',
  confirm: '确认',
  showMore: '查看更多',
  hideMore: '隐藏',
  per_sale: { 
    title: '预售阶段结束于 {days} 天 {hours} 小时 {mins} 分钟 {secs} 秒',
    title1: '参与Public Sale需要先进行KYC',
    text: '购买DLC',
    text1: '参与KYC'
  },
  meau: {
    nav1: '什么是DeepLink？',
    nav2: '怎么购买？',
    nav3: '白皮书',
    nav4: 'PITCH DECK',
    nav5: 'FAQ',
    nav6: 'Research',
    add: '地址:',
    link: '连接钱包'
  },
  home: {
    intro: {
      title: 'DeepLink Public Sale',
      text: '公开发售第一阶段倒计时:',
      text1: '当前KYC已经启动',
      text2: 'Public Sale阶段5结束倒计时',
      text3: '公开发售第二阶段倒计时:',
      tip: '请确保在购买（DLC）代币前完成客户身份认证（KYC）验证',
      tip1: '请勿重复购买'
    },
    desc: {
      title: 'Deeplink 包含两个组成部分：DeepLink Protocol 和 Deeplink Software',
      left: {
        text: '都使用 DeepLink 代币进行支付!',
        text1: 'DeepLink Porotocol是去中心化的AI云游戏协议，',
        text2: '结合AI和区块链技术提供超低延迟的游戏渲染技术，DeepLink Sosftware是基于DeepLink Porotocol开发的游戏远程控制软件和云游戏平台,基于DeepLink Porotocol开发的还有云网吧平台、区块链云游戏一体机、区块链云游戏掌机等等其他产品',
        text3: '100% Secure & Verified',
        btn1: 'DeepLink Protocol介绍',
        btn2: 'DeepLink Software介绍',
      },
      right: {
        text1: 'Public Sale正在进行中',
        text1_1: 'KYC正在进行中',
        text1_2: 'Public Sale阶段{pre_num1}正在进行中',
        // text2: 'DLC价格：1DLC={price}USDT, 剩余{days}天{hour}小时{min}分',
        text2: 'DLC价格：1DLC={price}USDT',
        text3: '第{pre_num}次Public Sale已经结束',
        text4: '阶段{pre_num1}即将开始',
        text5: 'Public Sale即将开始',
        text6: '请在参与公开销售前完成客户身份认证（KYC）流程。感谢您的合作。',
        // text7: '当前阶段额外奖励10%的Token，下个阶段奖励降低到5%',
        text7: '当前阶段额外奖励5%的Token，下个阶段无额外奖励',
        text8: '加入社区，参与抽奖送 10000 USDT和DLC活动',
        process: '已完成 {process}%',
        btn1: '参与KYC认证',
        btn1_1: 'KYC已通过',
        text7_1: '当前钱包KYC正在审核中，请等待',
        text7_2: '当前钱包KYC审核通过!',
        text7_3: '当前钱包KYC审核未通过，请重新提交！',
        text7_4: '当前钱包KYC未提交',
        btn2: '购买DLC TOKEN',
        btn3: '5%推荐链接',
        btn3_1: '10%推荐链接',
        btn3_2: '15%推荐链接',
        btn3_3: '20%推荐链接'
      },
      success: '链接已复制到剪切板',
      error1: '请先连接钱包，获取专属邀请码赢取奖励',
      error2: '未连接钱包，请先连接钱包',

      error3: 'KYC认证正在审核中，请等待审核后在进行购买',
      error4: 'KYC认证审核失败，如想购买，请重新提交KYC认证信息',
      error5: '获取KYC认证信息失败，请稍后再试',
      error6: '请在倒计时结束后参与购买。',
      error7: '阶段三已结束，请等待阶段四开启',
      tip1: 'DLC暂未发放',
      tip2: 'DLC已发放到用户钱包',
      tip3: '支付成功'
    },
    rule: {
      title: '规则说明',
      text1: 'KYC验证是必须的，需要提交身份证、护照或驾驶证等身份证明文件。新加坡、中国、美国、韩国以及某些其他国家的居民无法参与IDO。',
      text2: '公开销售结束后，DLC 将在7天内在DEX交易所上市，15天内在CEX交易所上市。DLC代币的BSC链智能合约地址：0xD610Be30b06A3828A27D608a38F1E85faAFdEDcC',
      text3: '购买20,000,000 DLC可以获得价值1500美元的DeepLink家用GPU游戏挖矿机。此优惠仅限于日本和欧洲，具体邮寄详情将通过电子邮件通知。',
      text3_btn: '了解家庭GPU游戏矿机',
      text4: '公开销售将在启动后48小时关闭，每个DLC的价格为0.003 USDT。40%的代币将保持解锁状态，其余60%将从2024年8月31日开始逐步解锁。需要注意的是：40%的DLC将在购买后的几分钟内转移到您指定的钱包地址，其余60%的DLC在锁定到期时转移到你的钱包地址。',
      text5: 'Public Sale分为5次进行，',
      table: {
        table1_text1: '阶段',
        table1_text2: '2024/06/05-06/07',
        table1_text3: '2024/06/09-06/29',
        table1_text4: '2024/06/29-07/13',
        table1_text5: '2024/07/13-08/05',
        table1_text6: '2024/08/05-09/11',
        table2_text1: 'DLC 数量',
        table2_text2: '350,000,000DLC',
        table2_text3: '400,000,000DLC',
        table2_text4: '300,000,000DLC',
        table2_text5: '450,000,000DLC',
        table2_text6: 'TBA',
        table3_text1: 'DLC 价格 (USDT)',
        table3_text2: '0.003',
        table3_text3: '0.003',
        table3_text4: '0.003',
        table3_text5: '0.003',
        table3_text6: '0.003',
        table4_text1: '奖金',
        table4_text2: '额外赠送 20% DLC',
        table4_text3: '额外赠送 15% DLC',
        table4_text4: '额外赠送 10% DLC',
        table4_text5: '额外赠送 5% DLC',
        table4_text6: 'NO',
        table5_text1: '数量',
        table5_text2: '1,050,000 USDT',
        table5_text3: '1,200,000 USDT',
        table5_text4: '900,000 USDT',
        table5_text5: '1,350,000 USDT',
        table5_text6: 'TBA'
      }
    },
    ecology: {
      title: 'DeepLink Protocol 生态系统概览',
      block1_title: 'DeepLink 软件',
      block1_text1: 'DeepLink软件核心功能是远程控制和云游戏平台',
      block1_text2: 'DeepLink Protocol 包括 DeepLink Protocol 和 DeepLink Software。在其核心，DeepLink Software 提供远程控制和云游戏功能，使用户能够参与远程游戏、远程工作和访问基于云的游戏服务。目前，该软件在全球110个国家拥有用户基础，下载量超过400,000次，全球创建的钱包数量超过200,000个。',
      block1_btn1: '了解DeepLink软件',
      block2_title: '云网吧和云电竞',
      block2_text1: '云网吧代表了网吧和电竞服务的创新模式，利用 DeepLink Protocol 的超低延迟渲染技术。',
      block2_text2: '在这种设置中，游戏和应用程序位于云GPU服务器上，而不是本地计算机，允许用户通过云服务访问和玩游戏，而不需要高性能的本地GPU主机。基于 DeepLink 技术的云网吧正在韩国、中国、日本、越南、菲律宾和印度等多个国家展开部署，参与开发的有 HYCONS、ZESTCLOUD、GLOWSTEAM 和 TIKEREN，韩国已有运营实例。',
      block2_btn1: '查看视频',
      block2_btn2: '了解云网吧',
      block3_title: '区块链云游戏一体机',
      block3_text1: '什么是云游戏一体机？',
      block3_text2: '区块链云游戏一体机代表了游戏硬件的飞跃，提供高FPS刷新率，为无缝的电竞游戏体验。由 HKC 集团开发的 TIKEREN 云游戏一体机利用 DeepLink 的超低延迟渲染技术，实时连接到云GPU服务器，提升游戏渲染性能。',
      block3_btn1: '了解区块链云游戏一体机',
      block4_title: '区块链云游戏掌机',
      block4_text1: '什么是云游戏掌机？',
      block4_text2: '基于 DeepLink 的超低延迟渲染技术构建的云游戏掌机，提供了一种与传统掌机相比成本效益更高的选择，同时提供流畅的3A游戏体验。通过连接到云GPU服务器进行实时游戏渲染，它将掌机成本降低了70%。',
      block4_btn1: '了解区块链云游戏掌机'
    },
    coverage: {
      title: 'DeepLink软件全球用户分布图',
      text: 'DeepLink用户总数：'
    },
    track: {
      title: 'DeepLink Protocol 是DePIN+AI+Game的组合赛道',
      text: '属于当前区块链行业的热门领域',
      block1_title: 'DeepLink市场规模有多大？',
      block1_text: "可以把DeepLink的其中一个功能理解为去中心化的XBOX和PlayStation，截止到2023年低 索尼的PS5 的全球销量达到了5000 万台， Xbox Series X{'|'}S 达到了 3000 万台，PS和Xbox总销量超过2亿台，高端3A游戏市场规模巨大.",
      block2_title: 'DeepLink和XBOX以及PlayStation一样都是服务高端3A游戏玩家，但是商业模式完全不一样',
      block2_text: 'DeepLink的游戏玩家不需要自己购买高端游戏主机，只需要下载DeepLink软件或者购买区块链云游戏一体机或者区块链云游戏掌机。玩家可以获得和XBOX和PlayStation一样的3A游戏体验，但是节省了80%的硬件成本。',
      block3_title: '由矿工提供高端3A游戏主机，主机是Windows系统，兼容所有Windows 3A游戏。',
      block3_text: '矿工的游戏主机可以放在家中也可以放在数据中心，Xbox和PlayStation的主机只能自己使用，无法出租给其他人使用，所以使用效率非常低，存在大量的资源浪费。而DeepLink的游戏矿机，可以共享给任何人使用，从而提高了硬件资源的利用率，带来了全新的商业模式。',
      block4_title: '矿工提供游戏矿机，可以获得DLC的代币奖励',
      block4_text: '从而刺激更多矿工提供游戏矿机，用户需要支付DLC Token购买游戏时长，从而扩大了DLC的使用场景和持币人数，潜在用户规模超过10亿人群。',
      table: {
        table1_text1: '详细对比',
        table1_text2: 'Deep Link',
        table1_text3: 'Xbox',
        table1_text4: 'PS5',
        table2_text1: '玩3A游戏',
        table2_text2: '用户无需购买硬件，只需要下载DeepLink软件',
        table2_text3: '用户需要购买硬件',
        table2_text4: '用户需要购买硬件',
        table3_text1: '游戏主机',
        table3_text2: '可以出租赚取$DLC，每天可以出租12个小时以上，10个月回本',
        table3_text3: '只能自己使用，无法出租，每天使用2-4个小时硬件资源存在浪费',
        table3_text4: '只能自己使用，无法出租，每天使用2-4个小时硬件资源存在浪费',
        table4_text1: '掌机',
        table4_text2: '支持，可以连接任何硬件',
        table4_text3: '无专用掌机',
        table4_text4: '支持，只能连接PS5',
        table5_text1: '云游戏一体机',
        table5_text2: '支持',
        table5_text3: '不支持',
        table5_text4: '不支持',
        table6_text1: '云网吧',
        table6_text2: '支持',
        table6_text3: '不支持',
        table6_text4: '不支持'
      },
      btn1: 'DeepLink Software',
      btn2: 'DeepLink Protocol',
      btn3: '团队介绍',
      btn4: '经济模型'
    },
    faqs: {
      title: 'FAQS',
      text: '您可能有疑问，我们有答案。',
      ques_title1: '1.什么是 Public Sale?',
      ques_text1: '在Public Sale期间，会以一定的价格出售有限数量的Token给希望早期参与的人。这是一个在实际的Token发行之前，人们可以成为DeepLink一部分的好机会。通过参与Public Sale，你可以在Token公开发行前以早鸟价格购买它。因此Public Sale可以被认为是在Token进入流通并在交易所上市之前购买它们的一个潜在机会。',
      ques_title2: '2.为什么我们要进行 Public Sale? ',
      ques_text2_1: '我们正在举行Public Sale活动，以建立一个强大的$DLC持有者社区，改善我们的平台并筹集资金，吸引更多游戏玩家进入我们的生态系统。',
      ques_text2_2: '在Public Sale期间筹集的资金将不断地再投资于DeepLink产品，引入新功能，并通过营销活动扩大用户基础。这将使我们能够在$DLC Token发行前执行我们的市场宣传策略。',
      ques_text2_3: '我们的目标是让1,000,000,000人使用DeepLink，这些将带来$DLC Token的巨大使用场景，并确保$DLC Token的长期成功。$DLC Token将在DEX和CEX交易所上市，进一步推动DeepLink生态系统的增长。',
      ques_text2_4: '现在就加入DeepLink  Public Sale，成为DeepLink的一部分！',
      ques_title3: '3.DeepLink Protocol和 DeepLink Software有什么区别？',
      ques_text3_1: 'DeepLink Porotocol是去中心化的AI云游戏协议，结合AI和区块链技术提供超低延迟的游戏渲染技术。',
      ques_text3_2: 'DeepLink Sosftware是基于DeepLink Porotocol开发的游戏远程控制软件和云游戏平台。',
      ques_text3_3: '基于DeepLink Porotocol开发的还有云电竞网吧平台、区块链云游戏一体机、区块链云游戏掌机等等其他产品',
      ques_title4: '4.DeepLink Protocol的创新在什么地方？',
      ques_text4: 'DeepLink通过区块链和AI技术解决云游戏行业遇到核心困难，通过Token激励机制吸引矿工和闲置GPU机器加入进来，吸引闲置带宽流量加入，从而解决云游戏行业遇到的两个关键难点。通过AI技术提升游戏画质，解决用户体验',
      ques_title5: '5.什么是 $DLC Token?',
      ques_text5: '$DLC Token是DeepLink生态系统中的唯一支付凭证，用户需要支付$DLC Token购买云游戏时长，租用云游戏电脑、购买Lincense授权等等',
      ques_title6: '6.DeepLink Protocol目标的客户是谁？',
      ques_text6_1: '1）3A游戏公司：给帮助3A游戏转化为云游戏，从而可以让3A游戏在任何低端设备包括手机上运行，帮助3A游戏的用户群体增加10倍以上',
      ques_text6_2: '2）网吧和电竞酒店：帮助传统网吧升级，改造成云网吧，网吧的硬件投资降低80%以上，4年时间净利润提高3倍',
      ques_text6_3: '3）云游戏一体机硬件厂商：厂商集成DeepLink Protocol，可以实现通过低端CPU配置+高端游戏屏幕实现畅玩3A游戏，帮助玩家节省80%的硬件投入',
      ques_text6_4: '4）云游戏掌机硬件厂商：厂商集成DeepLink Protocol，掌机价格是传统掌机价格的30%，游戏性能是传统掌机的5倍以上',
      ques_title7: '7.DeepLink Software目标的客户是谁？',
      ques_text7: '是全球30亿潜在的个人游戏玩家，满足游戏玩家可以用手机、性能差的电脑或者Mac和电视畅玩高端3A游戏',
      ques_title8: '8.Does it have a vesting period?',
      ques_text8: '购买的DLC Token 40%无锁定，60%从2024年8月31号前后3天开始解锁，分150天解锁，每30天解锁10%',
      ques_title9: '9.如何购买$DLC？',
      ques_text9: '首先参与KYC，提交个人信息，当认证通过后，启动Public Sale的时候就可以参与购买$DLC'
    },
    buy: {
      title: '如何购买?',
      step1: '步骤1：',
      step1_text: '连接您的Metamask钱包或Trust Wallet钱包',
      step2: '步骤2：',
      step2_text: '确认交易您可以使用USDT购买$DLC',
      step3: '步骤3：',
      step3_text: '您可以在公开发售结束后领取您的 $DLC',
      btn1: '需要帮助',
      btn2 : '购买DLC',
    },
    potential: {
      title: 'Growth Potential', 
      text1_1: 'DePIN赛道多个代币上线交易所后市值不断增长',
      text1_2: '$ 888',
      text1_3: '$ 2288',
      text1_4: '$ 5888',
      text1_5: '$ 12888',
      text2: 'DeepLink Softeware潜在用户规模超过10亿，会将大量web2用户带入web3世界，$DLC潜在持有者超过10亿人群。',
      text3: '全球有超过20万家电竞网吧，未来50%以上的传统网吧都会进行改造成云网吧，云网吧技术应用前景广泛，每个云网吧都需要使用$DLC进行支付，带来$DLC的大量使用。',
      text4: '参考XBOX和PS5的销售数量，购买区块链云游戏一体机和区块链云游戏掌机的用户群体将会超过1亿以上，将给带来$DLC巨大价值。'
    },
    report: {
      title: 'DeepLink 媒体报道'
    },
    prompt: {
      title: '说明提示',
      text1: 'DeepCloudX.PTE.LTD经营deeplink.cloud网站（“平台”）。',
      text2: '通过使用该平台，您接受我们的服务条款、隐私政策、Cookie政策和DLC代币销售协议。在您的司法辖区内，加密货币可能没有受到监管。加密货币的价值可能会上升也可能会下降。利润可能受到您的司法辖区内适用的资本利得税或其他税收的影响。本网站上的任何内容都不应被解释为购买、出售或投资的要约或建议。您完全负责根据您的个人目标、财务状况和风险承受能力，确定任何购买或相关交易是否适合您。',
      text3: '您应当咨询值得信任的、持有许可证的法律专业人员和顾问，以获取法律、税收、保险或业务建议。DLC不保证本网站上任何加密货币的任何性能、结果或资本回报。通过访问本网站及其任何页面，您同意受DLC销售协议的约束。购买加密货币涉及风险，可能导致部分或全部损失。',
    }
  },
  dialog1: {
    title: '提交KYC信息',
    text1: '上传身份信息：',
    text2: '上传手持身份信息：',
    text3: '身份证或者护照或者驾驶证的正面信息',
    text4: '需要清晰看清人脸正面以及身份信息',
    text5: '申请购买DLC的数量：',
    text6: '认证的钱包地址：',
    text7: 'KYC认证通过后奖励1000DLC， 并且Public Sale锁仓的DLC也会发送到此钱包地址',
    text7_1: '只能此地址通过KYC验证才能购买DLC，不能是交易所地址',
    text8: '在哪创建DBC链的DLC钱包地址？',
    text9: '或者',
    text10: '输入Email地址：',
    text11: '获得验证码',
    text12: '输入验证码：',
    text13: '{secs}秒后重新获取',
    text14: '(最多20,000,000DLC,Pubic Sale开始时只能按照KYC认证通过的数量购买)',

    success1: '验证码已发送!',
    success2: '提交信息成功,等待审核',
    error1: '必须选择图片文件!',
    error2: '图片文件不能为空!',
    error3: '用户名不能为空!',
    error4: '钱包地址不能为空!',
    error5: '邮箱不能为空!',
    error6: '请输入正确的邮箱地址!',
    error7: '验证码不能为空!',
    error8: '验证码发送失败，请稍后再试！',
    error9: '添加失败',
    error10: '验证码错误，请重试',
    error11: '查询邮箱信息失败',
    error12: '购买数量不能大于20000000',
    error13: '验证码超时，请重新获取',
    error14: '提交信息成功，发送确认邮件失败',
    error15: '如果未收到邮件，请检查是否被放置在垃圾邮件中',
    error16: '上传图片最大不能超过5M',
    error17: '请勿重复提交KYC认证数据',
    tip1: '(友情提示：个人身份信息仅仅作为KYC使用，不作任何其他用途)'
  },
  dialog2: {
    title: '购买DLC',
    text1: '申请购买DLC的数量：',
    text2: '最少需要购买150,000DLC',
    text3: '选择支付币种：',
    text4: '输入DBC链的DLC钱包地址：',
    // text5: '锁仓的DLC会打入此钱包地址，请确认钱包地址的正确性，防止收不到DLC！',
    text5: '40％ DLC会在几分钟内被转入到此钱包地址，剩下60％DLC在锁定到期的时间转入此钱包地址',
    text6: '在哪创建DBC链的DLC钱包地址？',
    text7: '或者',
    text8: '等值USDT:',
    text9: '选择支付方式: ',
    text9_1: '当前连接钱包支付',
    text9_2: '扫码支付',
    error1: 'DLC数量不能为空',
    error2: '请输入数字',
    error3: '输入的数字必须大于50000',
    error4: '钱包地址不能为空',
    error5: '创建订单失败',
    success1: '支付成功，DLC将在几分钟内转入您的钱包地址，请注意查收！',
    success2: '通过跳转链接支付成功后，DLC将在几分钟内转入您的钱包地址，请注意查收！',

    error6: 'USDT数量不能为空',
    error7: 'USDT数量不能小于150',
    error8: 'USDT数量不能大于60000',
    error9: '支付金额与预存入金额不一致，请联系管理员确认是否正确'
  },
  dialog3: {
    title: '一体机介绍',
    text1: '1.什么是云游戏一体机？',
    text2: '云游戏一体机相比较传统一体机显示器是高FPS刷新率，达到流程的游戏体验。 HKC集团的TIKEREN云游戏一体机是基于DeepBrainChain+DeepLink的技术研发的，可以实时连接远程高性能GPU算力 进行游戏渲染和计算。一体机内置Windows系统，可以作为正常办公娱乐使用，可以通过DeepLink串流到自己的其他高性能GPU主机玩游戏。 当自己没有高性能GPU主机，可以通过DeepLink连接到远程高性能GPU玩3A游戏，只需要每小时支付一定的DLC Token。',
    text3: '2.TIKEREN一体机展示',
    table: {
      th: {
        text1: '项目',
        text2: '27 英寸',
        text3: '31.5 英寸',
      },
      td1: {
        text1: 'Mode Type',
        text2: 'MA27H13QC1',
        text3: 'MA27H13QC1'
      },
      td2: {
        text1: 'Color Category',
        text2: 'Black',
        text3: 'Black'
      },
      td3: {
        text1: 'Display Size',
        text2: '27 英寸',
        text3: '31.5 英寸'
      },
      td4: {
        text1: 'Aspect Ratio',
        text2: 'Wide (16:9)',
        text3: 'Wide (16:9)'
      },
      td5: {
        text1: 'Panel Type',
        text2: 'IPS',
        text3: 'VA'
      },
      td6: {
        text1: 'Panel Resolution',
        text2: 'QHD 2560*1440',
        text3: 'QHD 2560*1440'
      },
      td7: {
        text1: 'Panel Refresh Rate',
        text2: '180Hz (Max)',
        text3: '170Hz(Max)'
      },
      td8: {
        text1: 'Responese Time',
        text2: '1mS(MPRT) GTG 1ms',
        text3: '1ms(MPRT) GTG 1ms'
      },
      td9: {
        text1: 'Color Gamut',
        text2: 'DCIP3 90%',
        text3: 'DCIP3 90%'
      },
      td10: {
        text1: 'Mainboard Solution',
        text2: 'Intel® N100 Chipset',
        text3: 'Intel® N100 Chipset'
      },
      td11: {
        text1: 'CPU/Cooler',
        text2: 'Intel N100 3.4GHz',
        text3: 'Intel N100 3.4GHz'
      },
      td12: {
        text1: 'Memory',
        text2: 'DDR4 8GB(Option Max 32G)',
        text3: 'DDR4 8GB(Option Max 32G)'
      },
      td13: {
        text1: 'Hard Disk',
        text2: 'SSD 128G(Option Max 1T)',
        text3: 'SSD 128G(Option Max 1T)'
      },
      td14: {
        text1: 'OS',
        text2: 'Windows 10/11(0ption)',
        text3: 'Windows 10/11(0ption)'
      },
      td15: {
        text1: 'GPU',
        text2: 'Intel UHD Graphics',
        text3: 'Intel UHD Graphics'
      },
      td16: {
        text1: 'Rear Interface',
        text2: '1*DC Power Connector，1*RJ45(2.5G)，4* USB 3.0，1*Audio jacks',
        text3: '1*DC Power Connector，1*HDMIN，1*HDMI OUT，1*RJ45(2.5G)，4* USB 3.0,1*Audio iacks'
      },
      td17: {
        text1: 'Side Interface',
        text2: 'USB 2.0x2，Power Button x1',
        text3: 'USB 2.0x2，Power Button x1'
      },
      td18: {
        text1: 'Wi-Fi',
        text2: '2.4G~5GHz(Wi-Fi5)，BT(4.2)',
        text3: '2.4G~5GHz(Wi-Fi5)，BT(4.2)'
      },
      td19: {
        text1: 'Audio',
        text2: 'Built-in Speakers*2',
        text3: 'Built-in Speakers*2'
      },
      td20: {
        text1: 'Base/Stand',
        text2: 'HAS:VESA',
        text3: 'HAS:VESA'
      },
      td21: {
        text1: 'Pivot',
        text2: '上，下，左，右，90°旋转，升降',
        text3: '上，下，左，右，90°旋转，升降'
      },
      td22: {
        text1: 'Power',
        text2: '90W',
        text3: '90W'
      },
      td23: {
        text1: 'Game Screen lmprovement',
        text2: 'Free Sync, G-Sync',
        text3: 'Free Sync, G-Sync'
      }
    },
    btn: '我知道了'
  },
  dialog4: {
    title: '云游戏掌机介绍',
    text1: '1.什么是云游戏掌机？',
    text2: '云游戏掌机相比较传统掌机的不同是基于DeepLink的超低延迟渲染技术研发的，可以实时连接云端GPU服务器高性能算力进行游戏渲染，从而实现掌机的成本降低70%，且可以实现流畅的3A游戏体验。掌机内置Google Play可以下载Android游戏，也可以通过串流到自己的其他高性能Windows GPU主机/PS/XOBX 玩游戏。当自己没有高性能GPU主机，也可以通过DeepLink连接到远程高性能GPU主机玩3A游戏，只需要每小时支付一定的DLC Token',
    text3: '2.区块链云游戏掌机展示',
    btn: '我知道了'
  },
  dialog5: {
    title: '家庭GPU游戏矿机介绍',
    text1: '1.什么是家庭GPU游戏矿机？',
    text2: 'GPU游戏矿机带有NVIDIA 4070 Super GPU，Intel i7-13700F CPU, 32G内存，2T SSD硬盘空间，内置DeepLink挖矿软件和管理系统任何人都可以将此机器放在家中赚取DLC奖励，每年有10亿的DLC Token奖励给所有的游戏矿机，无论是否有用户租用机器玩游戏都可以获得DLC奖励。当设置出租GPU游戏矿机，可以获得DLC奖励以及DBC的租金收益，当没有用户租用的时候还可以挖其他的代币，可以24小时产生收益。',
    text3: '2.家庭GPU游戏矿机展示',
    text4: '3.参数介绍',
    text5_1: 'With RTX4070 Super Graphics Card',
    text5_2: 'Core i7-13700F, 16 Cores, 24 Threads, Base 1.5/2.1 GHz, Max 4.1/5.1GHz;',
    text5_3: 'Graphics Card GeForce RTX4070 Supe12G. Support 3rd Gen Ray Tracing and 4th Tensor Core.',
    text5_4: 'RAM Dual DDR4, Max 64GB (32GB*2).',
    text5_5: 'Hard Drive Ports One M2 2280 NVME SSD, and support to add double 2.5" SATA hard drive.',
    text5_6: 'Ports 4*USB 3.2, 4* USB 2.0, 3*DisplayPort, 1*HDMI, 2*LAN, 1*Optical, 1*Audio, 1*DC-IN, 2*WiFi ports.',
    text5_7: 'Operating System Preinstall with Windows 11 Pro.',
    btn: '我知道了'
  }
}